export default __webpack_public_path__ + "static/media/login-cul-de-sac.c257234a.png";